import { render, staticRenderFns } from "./airBookingBasic.vue?vue&type=template&id=25c46eac&scoped=true&"
import script from "./airBookingBasic.vue?vue&type=script&lang=js&"
export * from "./airBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./airBookingBasic.vue?vue&type=style&index=0&id=25c46eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c46eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c46eac')) {
      api.createRecord('25c46eac', component.options)
    } else {
      api.reload('25c46eac', component.options)
    }
    module.hot.accept("./airBookingBasic.vue?vue&type=template&id=25c46eac&scoped=true&", function () {
      api.rerender('25c46eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/airBookingBasic.vue"
export default component.exports